import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const TOOLBAR_OPTIONS = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link', 'blockquote'],
  [{ align: [] }],
  ['clean'],
];

export default function RichTextEditor({
  label,
  value,
  onChange,
  placeholder,
  readOnly = false,
  minHeight = 160,
}) {
  const modules = useMemo(
    () => ({
      toolbar: readOnly ? false : TOOLBAR_OPTIONS,
    }),
    [readOnly]
  );

  return (
    <Box>
      {label ? (
        <Typography sx={{ fontSize: 13, fontWeight: 700, mb: 1, color: '#111827' }}>
          {label}
        </Typography>
      ) : null}
      <Box
        sx={{
          border: '1px solid #e5e7eb',
          borderRadius: 2,
          overflow: 'hidden',
          bgcolor: '#fff',
          '& .ql-toolbar': {
            border: 0,
            borderBottom: '1px solid #e5e7eb',
            background: '#f8fafc',
          },
          '& .ql-container': {
            border: 0,
            fontFamily: '"Inter", "Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            minHeight,
          },
          '& .ql-editor': {
            minHeight,
          },
        }}
      >
        <ReactQuill
          theme="snow"
          value={value || ''}
          onChange={onChange}
          placeholder={placeholder}
          modules={modules}
          readOnly={readOnly}
        />
      </Box>
    </Box>
  );
}

